// Fuerza es-MX en todo el proyecto, sin importar la configuración
// regional del dispositivo o del navegador.
import dayjs from 'dayjs';
import 'dayjs/locale/es-mx';
import moment from 'moment';
import 'moment/locale/es-mx';

export const APP_LOCALE = 'es-MX';

dayjs.locale('es-mx');
moment.locale('es-mx');

// Las llamadas toLocaleDateString()/toLocaleTimeString()/toLocaleString()
// sin argumentos usan la región del dispositivo; aquí se les fija es-MX
// como locale por defecto. Si alguna llamada pasa un locale explícito,
// ese se respeta.
const withDefaultLocale = (proto, method) => {
    const original = proto[method];
    proto[method] = function (locales, options) {
        const noLocale = locales == null || (Array.isArray(locales) && locales.length === 0);
        return original.call(this, noLocale ? APP_LOCALE : locales, options);
    };
};

withDefaultLocale(Date.prototype, 'toLocaleString');
withDefaultLocale(Date.prototype, 'toLocaleDateString');
withDefaultLocale(Date.prototype, 'toLocaleTimeString');
withDefaultLocale(Number.prototype, 'toLocaleString');
